export default __webpack_public_path__ + "static/media/enabled-badge-placeholder.1db28a43.svg";